module.exports = __webpack_public_path__ + "assets/img/145.93faa783.png";